import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateCommissionDividerModel,
} from '../../../models/commission-divider.model'

@Injectable({
  providedIn: 'root',
})
export class CommissionDividerService {
  private baseUrl = environment.baseUrl
  private resource = 'DivisorComissao'

  constructor(private httpClient: HttpClient) {}

  public createCommissionDivider(
    model: CreateCommissionDividerModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editCommissionDivider(
    model: any,
    // model: EditCommissionDividerModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  // public deleteCommissionDivider(
  //   model: DeleteCommissionDividerModel,
  // ): Observable<ResponseRequestModel> {
  //   return this.httpClient.post<ResponseRequestModel>(
  //     `${this.baseUrl}${this.resource}/delete`,
  //     model,
  //   )
  // }

  public listPagedCommissionDivider(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  // public searchCommissionDivider(
  //   model: SearchCommissionDividerModel,
  // ): Observable<ResponseRequestModel> {
  //   return this.httpClient.post<ResponseRequestModel>(
  //     `${this.baseUrl}${this.resource}/search`,
  //     model,
  //   )
  // }

  public listCommissionDivider(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getCommissionDividerbyId(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  // public searchPagedCommissionDivider(
  //   page: number,
  //   rows: number = 15,
  //   model: SearchCommissionDividerModel,
  // ): Observable<ResponseRequestModel> {
  //   return this.httpClient.post<ResponseRequestModel>(
  //     `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
  //     model,
  //   )
  // }

  public getCommissionDividerbyClientId(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list/cliente/${id}`,
    )
  }

  public getCommissionDividerDefault(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list/tgmob`,
    )
  }
}
